var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.locations,"rules":_vm.rules,"label":_vm.$t('appointment.formCreate.labels.location'),"item-value":"value","item-text":"label","outlined":""},on:{"change":_vm.handleMetingLocation}})}
var staticRenderFns = []

export { render, staticRenderFns }